<template>
  <div class="table-responsive adaptive-table sentMessageTable" v-if="list.length > 0">
    <table class="table table-striped table-hover " style="width:100%">
      <thead>
        <tr>
          <th v-for="(item, key) in fields" :class="item === 'text' ? 'col-md-4' : ''" :key="key">{{ $t(item) }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in list" :key="row.id" @click="prepareInfo(row)">
          <td class="sentMessageTable-recipient" :data-label="$t('recipient')">{{ row.recipient }}</td>
          <td class="sentMessageTable-textWrapper  d-none d-md-block" :data-label="$t('text')">
            <span class="sentMessageTable-text">{{ row.text }}</span>
          </td>
          <td class="d-block d-md-none" :data-label="$t('text')">
            {{ row.text }}
          </td>
          <td class="sentMessageTable-status" :data-label="$t('status')">{{ $t(`messagesStatus.${row.status}`) }}</td>
          <td class="sentMessageTable-sandbox" :data-label="$t('sandbox')">{{ row.sandbox ? $t('yes') : $t('no') }}</td>
          <td class="sentMessageTable-date" :data-label="$t('date')">{{ humanDateTime(row.create_date, $i18n.locale) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'
import { useHumanDate } from '@/application/composables/humanDate.js'
import { useTableHandlers } from '@/application/composables/messagesTable.js'

export default {
  name: 'SentMessagesTable',
  props: {
    list: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const { humanDateTime } = useHumanDate()
    const i18n = useI18n()
    const { openModal } = useTableHandlers()
    const fields = ['recipient', 'text', 'status', 'sandbox', 'date']
    const prepareInfo = (info) => {
      const obj = {
        status: i18n.t(`messagesStatus.${info.status}`),
        recipient: info.recipient,
        text: info.text,
        mediaURL: info.media_url || '',
        sandbox: info.sandbox ? i18n.t('yes') : i18n.t('no'),
        date: humanDateTime(info.create_date, i18n.locale),
      }
      openModal(obj)
    }
    return {
      humanDateTime,
      prepareInfo,
      fields,
    }
  },
}
</script>
